/**
 * The company website, in one place.
 *
 * `www.gospeednet.co.ke`, and nothing anywhere should say `.com`.
 *
 * Both were in play for a while and the `.com` spelling reached this file. It
 * is the wrong one, and being wrong here is not cosmetic: the console links to
 * it from the logo on every screen, the sign-in panel and the contract
 * footer, and a customer who follows a link to a domain the company does not
 * own has been sent somewhere nobody controls.
 *
 * The rest of the system already agreed — every seeded address, the outbound
 * `EMAIL_FROM`, the FormSubmit origin header and the SPF/DKIM notes in
 * docs/EMAIL.md are all `.co.ke`. This constant now matches them.
 *
 * It is the whole surface. Point it wherever the site lives and every link in
 * the console follows — the logo, the sign-in panel, the contract documents,
 * and anything added later.
 */
export const COMPANY_SITE = 'https://www.gospeednet.co.ke';

/** What a person reads on a confirmation dialog. No scheme, no trailing slash. */
export const COMPANY_SITE_LABEL = 'www.gospeednet.co.ke';

/**
 * Is this URL somewhere else?
 *
 * Used to decide whether leaving needs confirming. Anything that will not parse
 * counts as external: a malformed link is exactly the sort that should not be
 * followed without a person looking at it first.
 */
export function isExternal(url: string): boolean {
  try {
    return new URL(url, window.location.origin).origin !== window.location.origin;
  } catch {
    return true;
  }
}
